import routes from '@/config/routes'
import authenticationService from '@/services/authentication.service'
import authenticationLocalStorageService from '@/services/authentication-local-storage.service'
import parametersService from '@/services/parameters.service'
import store from '@/store'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router(routes)

const shouldShowRouteConfirmDialog = async (): Promise<boolean> => {
  if (
    store.getters.actionToHandleUnsavedWork &&
    (await store.getters.actionToHandleUnsavedWork())
  ) {
    return false
  }

  return true
}

router.beforeEach(async (to, from, next) => {
  if (store.getters.isThereWorkToBeSaved) {
    if (await shouldShowRouteConfirmDialog()) {
      return store.dispatch('openConfirmRouteChangeDialog', to.path)
    }

    store.dispatch('thereIsNotUnsavedWork')
  }

  const token = to.query.token

  store.dispatch('setAppIsLoading', true)

  if (!parametersService.existParameters()) {
    await parametersService.getParameters()
  }

  if (token) {
    authenticationLocalStorageService.resetUser()
  }

  if (!authenticationService.existUserCredentials()) {
    if (token) {
      authenticationService.setUserDataFromToken(token as string)
      authenticationService.redirectToPrevLocation()
    } else {
      authenticationService.saveCurrentLocationAsPrev(to)
      authenticationService.authenticateUser()
    }
  } else if (!authenticationService.existUserData()) {
    authenticationService.setUserDataFromLocalStorage()
  }

  next()
})

router.afterEach((to, from) => {
  if (
    authenticationService.existUserCredentials() &&
    authenticationService.existUserData()
  ) {
    store.dispatch('setAppIsLoading', false)
  }
})

export default router
